import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function ToulonAirportPage() {
  const [tripType, setTripType] = useState<'oneway' | 'return'>('oneway');
  const [passengers, setPassengers] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const trendingTransfers = [
    {
      destination: 'St Tropez',
      price: '144.95',
      image: 'https://public.readdy.ai/ai/img_res/60b41c4367300ec08005361db200ab7b.jpg'
    },
    {
      destination: 'Grimaud',
      price: '132.95',
      image: 'https://readdy.ai/api/search-image?query=Grimaud%20medieval%20hilltop%20village%20stone%20houses%20and%20castle%20ruins%20Provence%20France%20picturesque%20scenery%20surrounded%20by%20green%20hills%20simple%20background&width=400&height=280&seq=ttln2&orientation=landscape'
    },
    {
      destination: 'Marseille Aéroport',
      price: '179.95',
      image: 'https://readdy.ai/api/search-image?query=Modern%20airport%20terminal%20building%20with%20glass%20facade%20and%20planes%20on%20tarmac%20sunny%20day%20clean%20architecture%20simple%20background%20Mediterranean%20style&width=400&height=280&seq=ttln3&orientation=landscape'
    },
    {
      destination: 'Sainte Maxime',
      price: '137.95',
      image: 'https://readdy.ai/api/search-image?query=Sainte-Maxime%20beach%20promenade%20with%20palm%20trees%20Mediterranean%20seaside%20resort%20French%20Riviera%20sandy%20beach%20blue%20waters%20sunny%20atmosphere%20simple%20background&width=400&height=280&seq=ttln4&orientation=landscape'
    },
    {
      destination: 'Le Lavandou',
      price: '67.95',
      image: 'https://readdy.ai/api/search-image?query=Le%20Lavandou%20coastal%20village%20with%20beach%20and%20boats%20Provence%20Mediterranean%20coast%20colorful%20houses%20and%20clear%20turquoise%20water%20simple%20background&width=400&height=280&seq=ttln5&orientation=landscape'
    },
    {
      destination: 'Ramatuelle',
      price: '147.95',
      image: 'https://readdy.ai/api/search-image?query=Ramatuelle%20hilltop%20village%20with%20stone%20buildings%20and%20vineyards%20Provence%20France%20panoramic%20views%20Mediterranean%20landscape%20simple%20background&width=400&height=280&seq=ttln6&orientation=landscape'
    },
    {
      destination: 'Nice Aéroport',
      price: '279.95',
      image: 'https://readdy.ai/api/search-image?query=Nice%20Cote%20d%20Azur%20airport%20modern%20terminal%20with%20mountains%20in%20background%20French%20Riviera%20aviation%20hub%20blue%20sky%20simple%20background&width=400&height=280&seq=ttln7&orientation=landscape'
    },
    {
      destination: 'Cavalaire-Sur-Mer',
      price: '110.95',
      image: 'https://readdy.ai/api/search-image?query=Cavalaire-sur-Mer%20sandy%20beach%20with%20Mediterranean%20sea%20and%20boats%20French%20Riviera%20coastal%20resort%20palm%20trees%20sunny%20day%20simple%20background&width=400&height=280&seq=ttln8&orientation=landscape'
    },
    {
      destination: 'Toulon',
      price: '68.95',
      image: 'https://readdy.ai/api/search-image?query=Toulon%20harbor%20with%20boats%20and%20historic%20buildings%20French%20naval%20port%20Mediterranean%20city%20colorful%20facades%20sunny%20atmosphere%20simple%20background&width=400&height=280&seq=ttln9&orientation=landscape'
    },
    {
      destination: 'Bormes-Les-Mimosas',
      price: '62.95',
      image: 'https://readdy.ai/api/search-image?query=Bormes-les-Mimosas%20charming%20village%20with%20yellow%20mimosa%20flowers%20Provence%20medieval%20streets%20colorful%20houses%20simple%20background&width=400&height=280&seq=ttln10&orientation=landscape'
    },
    {
      destination: 'Gassin',
      price: '129.95',
      image: 'https://readdy.ai/api/search-image?query=Gassin%20hilltop%20village%20with%20stone%20houses%20and%20panoramic%20views%20Provence%20France%20Mediterranean%20landscape%20vineyards%20simple%20background&width=400&height=280&seq=ttln11&orientation=landscape'
    },
    {
      destination: 'La Croix Valmer',
      price: '130.95',
      image: 'https://readdy.ai/api/search-image?query=La%20Croix-Valmer%20coastal%20village%20with%20beaches%20and%20Mediterranean%20scenery%20French%20Riviera%20turquoise%20waters%20sunny%20day%20simple%20background&width=400&height=280&seq=ttln12&orientation=landscape'
    },
    {
      destination: 'Lorgues',
      price: '172.95',
      image: 'https://readdy.ai/api/search-image?query=Lorgues%20historic%20Provence%20village%20with%20plane%20trees%20and%20fountains%20traditional%20architecture%20colorful%20market%20square%20simple%20background&width=400&height=280&seq=ttln13&orientation=landscape'
    },
    {
      destination: 'Hyeres',
      price: '56.95',
      image: 'https://readdy.ai/api/search-image?query=Hyeres%20old%20town%20with%20palm%20trees%20and%20medieval%20architecture%20Provence%20France%20colorful%20buildings%20sunny%20Mediterranean%20atmosphere%20simple%20background&width=400&height=280&seq=ttln14&orientation=landscape'
    },
    {
      destination: 'Marseille',
      price: '177.95',
      image: 'https://readdy.ai/api/search-image?query=Marseille%20Old%20Port%20with%20boats%20and%20colorful%20buildings%20Notre-Dame%20de%20la%20Garde%20basilica%20Mediterranean%20city%20sunny%20day%20simple%20background&width=400&height=280&seq=ttln15&orientation=landscape'
    },
    {
      destination: 'Cogolin',
      price: '111.95',
      image: 'https://readdy.ai/api/search-image?query=Cogolin%20Provence%20village%20with%20traditional%20architecture%20and%20crafts%20workshops%20colorful%20streets%20Mediterranean%20atmosphere%20simple%20background&width=400&height=280&seq=ttln16&orientation=landscape'
    },
    {
      destination: 'Bandol',
      price: '108.95',
      image: 'https://readdy.ai/api/search-image?query=Bandol%20seaside%20resort%20with%20vineyards%20and%20beaches%20Provence%20French%20Riviera%20harbor%20with%20boats%20sunny%20day%20simple%20background&width=400&height=280&seq=ttln17&orientation=landscape'
    },
    {
      destination: 'Camping Les Prairies De La Mer',
      price: '127.95',
      image: 'https://readdy.ai/api/search-image?query=Mediterranean%20coastal%20camping%20resort%20with%20palm%20trees%20and%20beach%20access%20French%20Riviera%20vacation%20destination%20sunny%20atmosphere%20simple%20background&width=400&height=280&seq=ttln18&orientation=landscape'
    },
    {
      destination: 'La Ciotat',
      price: '153.95',
      image: 'https://readdy.ai/api/search-image?query=La%20Ciotat%20harbor%20with%20boats%20and%20calanques%20cliffs%20Provence%20Mediterranean%20coast%20colorful%20facades%20sunny%20day%20simple%20background&width=400&height=280&seq=ttln19&orientation=landscape'
    },
    {
      destination: 'Lavaur',
      price: '677.95',
      image: 'https://readdy.ai/api/search-image?query=Lavaur%20historic%20town%20with%20cathedral%20and%20traditional%20architecture%20southern%20France%20medieval%20charm%20simple%20background&width=400&height=280&seq=ttln20&orientation=landscape'
    }
  ];

  const features = [
    {
      icon: 'ri-user-star-line',
      title: 'Chauffeurs locaux professionnels',
      description: 'Experts de la région'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Tarifs fixes et transparents',
      description: 'Aucun coût caché'
    },
    {
      icon: 'ri-flight-takeoff-line',
      title: 'Suivi des vols',
      description: 'Prises en charge ponctuelles'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Assistance 24/7',
      description: 'Annulations simples'
    }
  ];

  const benefits = [
    {
      icon: 'ri-money-euro-circle-line',
      title: 'Tarifs tout compris',
      description: 'Prix transparent sans surprise'
    },
    {
      icon: 'ri-bank-card-line',
      title: 'Options de paiement flexibles',
      description: 'Plusieurs moyens de paiement'
    },
    {
      icon: 'ri-time-line',
      title: 'Temps d\'attente gratuit',
      description: 'Pas de frais d\'attente'
    },
    {
      icon: 'ri-car-line',
      title: 'Sélection variée de véhicules',
      description: 'Choix adapté à vos besoins'
    }
  ];

  const steps = [
    {
      icon: 'ri-smartphone-line',
      title: 'Réservez Facilement',
      description: 'Réservation en ligne rapide avec confirmation immédiate.'
    },
    {
      icon: 'ri-user-smile-line',
      title: 'Rencontrez votre chauffeur',
      description: 'Un visage accueillant vous attend à l\'arrivée.'
    },
    {
      icon: 'ri-steering-2-line',
      title: 'Profitez du trajet',
      description: 'Transfert privé et fiable jusqu\'à votre destination.'
    }
  ];

  return (
    <div className="min-h-screen bg-white font-inter">
      <Navbar />

      {/* Hero Section avec formulaire */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-night-blue via-slate-800 to-night-blue"></div>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-alpine-gold rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-amber-500 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-12"
          >
            <h1 className="font-playfair font-bold text-4xl sm:text-5xl lg:text-6xl text-white mb-6">
              Transferts depuis Toulon Aéroport
            </h1>
            <p className="text-lg sm:text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
              Nos chauffeurs professionnels et expérimentés vous accueillent dans la zone d'attente de l'aéroport et vous aident avec vos bagages puis vous conduisent en toute sécurité à votre destination.
            </p>
          </motion.div>

          {/* Formulaire de réservation */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 max-w-5xl mx-auto"
          >
            {/* Type de trajet */}
            <div className="flex gap-4 mb-6">
              <button
                onClick={() => setTripType('oneway')}
                className={`flex-1 py-3 px-6 rounded-full font-inter font-medium transition-all whitespace-nowrap cursor-pointer ${
                  tripType === 'oneway'
                    ? 'bg-gradient-to-r from-alpine-gold to-amber-500 text-night-blue shadow-lg'
                    : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                }`}
              >
                Aller simple
              </button>
              <button
                onClick={() => setTripType('return')}
                className={`flex-1 py-3 px-6 rounded-full font-inter font-medium transition-all whitespace-nowrap cursor-pointer ${
                  tripType === 'return'
                    ? 'bg-gradient-to-r from-alpine-gold to-amber-500 text-night-blue shadow-lg'
                    : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                }`}
              >
                Aller-retour
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  Destination
                </label>
                <select className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-alpine-gold focus:border-transparent text-sm cursor-pointer">
                  <option>Sélectionnez votre destination</option>
                  {trendingTransfers.map((transfer) => (
                    <option key={transfer.destination}>{transfer.destination}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  Date de départ
                </label>
                <input
                  type="date"
                  className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-alpine-gold focus:border-transparent text-sm cursor-pointer"
                />
              </div>
            </div>

            {tripType === 'return' && (
              <div className="mb-4">
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  Date de retour
                </label>
                <input
                  type="date"
                  className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-alpine-gold focus:border-transparent text-sm cursor-pointer"
                />
              </div>
            )}

            <div className="mb-6">
              <label className="block text-sm font-medium text-slate-700 mb-2">
                Nombre de passagers
              </label>
              <div className="flex items-center gap-4">
                <button
                  onClick={() => setPassengers(Math.max(1, passengers - 1))}
                  className="w-10 h-10 flex items-center justify-center bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors cursor-pointer"
                >
                  <i className="ri-subtract-line text-slate-700"></i>
                </button>
                <span className="text-xl font-medium text-night-blue w-12 text-center">
                  {passengers}
                </span>
                <button
                  onClick={() => setPassengers(Math.min(8, passengers + 1))}
                  className="w-10 h-10 flex items-center justify-center bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors cursor-pointer"
                >
                  <i className="ri-add-line text-slate-700"></i>
                </button>
              </div>
            </div>

            <button className="w-full py-4 bg-gradient-to-r from-alpine-gold to-amber-500 text-night-blue rounded-full font-inter font-bold text-lg hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer">
              Réserver maintenant
            </button>
          </motion.div>
        </div>
      </section>

      {/* Trust Badges */}
      <section className="py-12 bg-gradient-to-r from-slate-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-gradient-to-br from-alpine-gold to-amber-500 rounded-full flex items-center justify-center mb-4">
                <i className="ri-team-line text-white text-2xl"></i>
              </div>
              <h3 className="font-playfair font-bold text-2xl text-night-blue mb-2">
                Des millions
              </h3>
              <p className="text-slate-600">de personnes nous font confiance</p>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-gradient-to-br from-alpine-gold to-amber-500 rounded-full flex items-center justify-center mb-4">
                <i className="ri-customer-service-2-line text-white text-2xl"></i>
              </div>
              <h3 className="font-playfair font-bold text-2xl text-night-blue mb-2">
                Service 24/7
              </h3>
              <p className="text-slate-600">Assistance disponible en continu</p>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-gradient-to-br from-alpine-gold to-amber-500 rounded-full flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <h3 className="font-playfair font-bold text-2xl text-night-blue mb-2">
                Personnalisé
              </h3>
              <p className="text-slate-600">et sécurisé</p>
            </div>
          </div>
        </div>
      </section>

      {/* Trending Transfers */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="font-playfair font-bold text-4xl sm:text-5xl text-night-blue mb-4">
              Les transferts tendances vers Toulon Aéroport
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {trendingTransfers.map((transfer, index) => (
              <motion.div
                key={transfer.destination}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all hover:scale-105 cursor-pointer group"
              >
                <div className="relative w-full h-48 overflow-hidden">
                  <img
                    src={transfer.image}
                    alt={transfer.destination}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <h3 className="font-playfair font-bold text-lg text-night-blue mb-2">
                    Toulon Aéroport → {transfer.destination}
                  </h3>
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-slate-600 mb-1">Prix à partir de</p>
                      <p className="font-inter font-bold text-2xl text-alpine-gold">
                        €{transfer.price}
                      </p>
                    </div>
                    <button className="px-4 py-2 bg-night-blue text-white rounded-lg hover:bg-alpine-gold hover:text-night-blue transition-all whitespace-nowrap cursor-pointer">
                      Réserver
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Airport Pickup Section */}
      <section className="py-20 bg-gradient-to-br from-slate-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="font-playfair font-bold text-4xl text-night-blue mb-6">
                Prise en charge à l'aéroport
              </h2>
              <p className="text-lg text-slate-600 mb-8 leading-relaxed">
                Évitez la file d'attente des taxis grâce à une course pré-réservée à des tarifs compétitifs.
              </p>

              <h3 className="font-playfair font-bold text-2xl text-night-blue mb-6">
                Ce que nous offrons :
              </h3>

              <div className="space-y-4">
                {features.map((feature, index) => (
                  <motion.div
                    key={feature.title}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.1 }}
                    className="flex items-start gap-4"
                  >
                    <div className="w-12 h-12 bg-gradient-to-br from-alpine-gold to-amber-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${feature.icon} text-white text-xl`}></i>
                    </div>
                    <div>
                      <h4 className="font-inter font-bold text-lg text-night-blue mb-1">
                        {feature.title}
                      </h4>
                      <p className="text-slate-600">{feature.description}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="relative w-full h-96 rounded-2xl overflow-hidden shadow-2xl"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20chauffeur%20waiting%20at%20airport%20arrivals%20hall%20with%20welcome%20sign%20luxury%20airport%20transfer%20service%20elegant%20uniform%20simple%20background&width=600&height=400&seq=ttlnpickup&orientation=landscape"
                alt="Prise en charge aéroport"
                className="w-full h-full object-cover object-top"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="font-playfair font-bold text-4xl sm:text-5xl text-night-blue mb-4">
              Pourquoi choisir un transfert de Toulon Aéroport
            </h2>
            <p className="text-xl text-slate-600">Il y a d'innombrables avantages</p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {benefits.map((benefit, index) => (
              <motion.div
                key={benefit.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all text-center group hover:scale-105"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-alpine-gold to-amber-500 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                  <i className={`${benefit.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="font-playfair font-bold text-xl text-night-blue mb-3">
                  {benefit.title}
                </h3>
                <p className="text-slate-600">{benefit.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* How it Works */}
      <section className="py-20 bg-gradient-to-br from-slate-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="font-playfair font-bold text-4xl sm:text-5xl text-night-blue mb-4">
              Voyagez simplement
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <motion.div
                key={step.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.2 }}
                className="relative text-center"
              >
                <div className="w-20 h-20 bg-gradient-to-br from-alpine-gold to-amber-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-xl">
                  <i className={`${step.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="font-playfair font-bold text-2xl text-night-blue mb-4">
                  {step.title}
                </h3>
                <p className="text-lg text-slate-600 leading-relaxed">
                  {step.description}
                </p>
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-10 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-alpine-gold to-amber-500"></div>
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Private Transfer Advantages */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="relative w-full h-96 rounded-2xl overflow-hidden shadow-2xl"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Luxury%20black%20Mercedes%20sedan%20interior%20with%20comfortable%20leather%20seats%20premium%20airport%20transfer%20vehicle%20elegant%20design%20simple%20background&width=600&height=400&seq=ttlnprivate&orientation=landscape"
                alt="Transfert privé"
                className="w-full h-full object-cover object-top"
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="font-playfair font-bold text-4xl text-night-blue mb-6">
                Avantages des transferts privés
              </h2>
              <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                Les transferts privés depuis l'aéroport offrent l'itinéraire le plus rapide et le plus pratique de Toulon Aéroport directement à votre destination. Évitez le stress des tarifs élevés des taxis ou de la navigation dans les transports en commun après votre vol. En quelques clics, assurez-vous un trajet confortable et sûr à un prix fixe et abordable.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed">
                Un chauffeur professionnel vous accueillera à l'arrivée, vous aidera avec vos bagages et vous accompagnera à votre véhicule. Pendant votre trajet, profitez du Wi-Fi et de l'accès à l'assistance client 24h/24 et 7j/7 pour tous besoins ou réservations supplémentaires. Profitez d'un service porte-à-porte sans frais cachés - parfait pour gagner du temps et améliorer votre expérience de voyage.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-night-blue via-slate-800 to-night-blue relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-alpine-gold rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-amber-500 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="font-playfair font-bold text-4xl sm:text-5xl text-white mb-6">
              Découvrez comment nous améliorons votre façon de voyager
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
              Connecté à travers le monde depuis plus d'une décennie
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="/reservation"
                className="px-8 py-4 bg-gradient-to-r from-alpine-gold to-amber-500 text-night-blue rounded-full font-inter font-bold text-lg hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
              >
                Réserver maintenant
              </a>
              <a
                href="tel:+33605606006"
                className="px-8 py-4 bg-white/10 text-white rounded-full font-inter font-bold text-lg hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm border border-white/20"
              >
                <i className="ri-phone-line mr-2"></i>
                +33 6 05 60 60 06
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
